import React, { useState } from "react"

type Props = {
  onSearch: (value: string) => void
  placeholder?: string
  defaultValue?: string
}

// Bordered search input with a leading icon plus an explicit Search button.
// Submits on button click or Enter; clearing the field resets the search.
export const SearchBox: React.FC<Props> = ({ onSearch, placeholder = "Search", defaultValue = "" }) => {
  const [value, setValue] = useState(defaultValue)

  return (
    <form
      className="wb-clients__search"
      onSubmit={(e) => {
        e.preventDefault()
        onSearch(value.trim())
      }}
    >
      <div className="wb-clients__search-wrap">
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="#98A2B3" strokeWidth="1.6" strokeLinecap="round">
          <circle cx="7" cy="7" r="4.5" />
          <path d="M14 14l-3.2-3.2" />
        </svg>
        <input
          type="search"
          className="wb-clients__search-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            setValue(e.target.value)
            if (e.target.value === "") onSearch("")
          }}
        />
      </div>
      <button type="submit" className="wb-clients__search-btn">Search</button>
    </form>
  )
}
